import React from 'react';
import LegalDoc from './LegalDoc';
import content from './SUBPROCESSORS.md?raw';

const Subprocessors = () => <LegalDoc content={content} />;

export default Subprocessors;
